export const questions = [
  {
    id: 'homeownership',
    question: "Do you own or rent your home?",
    type: 'single',
    options: [
      { id: 'own', label: "Own my home", value: 'own' },
      { id: 'rent', label: "Rent (but interested in renter's insurance)", value: 'rent' },
      { id: 'condo', label: "Own a condo/townhome", value: 'condo' },
      { id: 'sell_soon', label: "Own but planning to sell soon", value: 'sell_soon' }
    ]
  },
  {
    id: 'lastReview',
    question: "When did you last review your home insurance policy?",
    type: 'single',
    options: [
      { id: 'within_year', label: "Within the past year", value: 'within_year' },
      { id: '1-2_years', label: "1-2 years ago", value: '1-2_years' },
      { id: '3-5_years', label: "3-5 years ago", value: '3-5_years' },
      { id: '5+_years', label: "5+ years ago", value: '5+_years' },
      { id: 'never', label: "Never reviewed it / Don't know", value: 'never' }
    ]
  },
  {
    id: 'replacementCost',
    question: "Do you know your home's current replacement cost?",
    subtext: "(Not the market value - replacement cost is what it would cost to rebuild your home from scratch)",
    type: 'single',
    options: [
      { id: 'yes', label: "Yes, it's up to date", value: 'yes' },
      { id: 'think_so', label: "I think so, but not sure", value: 'think_so' },
      { id: 'no', label: "No, I don't know", value: 'no' },
      { id: 'whats_difference', label: "What's the difference between replacement cost and market value?", value: 'whats_difference' }
    ]
  },
  {
    id: 'mainConcern',
    question: "What's your biggest concern about your home insurance?",
    type: 'single',
    options: [
      { id: 'paying_too_much', label: "Paying too much", value: 'paying_too_much' },
      { id: 'not_enough_coverage', label: "Don't have enough coverage", value: 'not_enough_coverage' },
      { id: 'dont_understand', label: "Don't understand my policy", value: 'dont_understand' },
      { id: 'coverage_gaps', label: "Worried about coverage gaps (flood, earthquake, etc.)", value: 'coverage_gaps' },
      { id: 'not_sure', label: "Not sure what I actually have", value: 'not_sure' },
      { id: 'everything_fine', label: "Everything seems fine", value: 'everything_fine' }
    ]
  },
  {
    id: 'additionalStructures',
    question: "Do you have any of these on your property?",
    subtext: "Select all that apply",
    type: 'multiple',
    options: [
      { id: 'pool', label: "Swimming pool", value: 'pool' },
      { id: 'garage', label: "Detached garage/shed", value: 'garage' },
      { id: 'adu', label: "Guesthouse or ADU", value: 'adu' },
      { id: 'trampoline', label: "Trampoline", value: 'trampoline' },
      { id: 'business', label: "Home business equipment", value: 'business' },
      { id: 'high_value', label: "High-value items (jewelry, art, >$5K)", value: 'high_value' },
      { id: 'none', label: "None of the above", value: 'none' }
    ]
  },
  {
    id: 'disasterCoverage',
    question: "Are you in an area that needs special coverage for natural disasters?",
    type: 'multiple',
    options: [
      { id: 'earthquake', label: "Yes, earthquake zone (CA-specific)", value: 'earthquake' },
      { id: 'flood', label: "Yes, flood zone", value: 'flood' },
      { id: 'wildfire', label: "Yes, wildfire risk area", value: 'wildfire' },
      { id: 'not_sure', label: "Not sure / Don't know", value: 'not_sure' },
      { id: 'no_risks', label: "No special risks", value: 'no_risks' }
    ]
  }
];